import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// let tracking=require('tracking')
import baseUrl from './config'; // 这里设置了一个文件作为所有请求的基础ip地址
import configJson from './configJson'; // 这里设置了一个文件作为所有请求的基础ip地址

import { SVG } from '@svgdotjs/svg.js'
Vue.prototype.SVG = SVG;

Vue.config.productionTip = false
import server from '../src/services/server';
Vue.prototype.$server = server;
//video插件
import Video from 'video.js'
import 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video
require('audiojs');
import audio from 'audiojs'
Vue.prototype.$audio = audio
//iview插件
import 'view-design/dist/styles/iview.css';
import { Select, Option, Icon } from 'view-design';
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Icon', Icon);

import 'element-ui/lib/theme-chalk/index.css';
import {  Carousel, CarouselItem, } from 'element-ui';
Vue.component('Carousel', Carousel);
Vue.component('CarouselItem', CarouselItem);
//echarts插件
//引入基本模板
let echarts = require('echarts/lib/echarts')

// 引入折线图等组件
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/radar')
require('echarts/lib/chart/custom')

// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/legendScroll')//图例翻译滚动
require('echarts/lib/component/markLine')//图例翻译滚动
require('echarts/lib/component/dataZoom')//图例翻译滚动

Vue.prototype.$echarts = echarts;

//全局样式
import  './assets/css/style.less';
import  './assets/css/title.less';
//动画
// import 'vue2-animate/dist/vue2-animate.min.css'
import './assets/css/transition.less'
import 'animate.css' // npm install animate.css --save安装，在引入

//外部js
// import './assets/js/generated/RealTimeChatService_pb';
import record from './assets/js/record';
import global from './assets/js/global';
Vue.prototype.$record=record;
Vue.prototype.$global=global;
//AI 识别json串
import aiJson from  './assets/json/ai.json';
import imgJson from './assets/json/img.js';
Vue.prototype.$aiJson=aiJson;
Vue.prototype.$imgJson=imgJson;
Vue.prototype.baseUrl = baseUrl;
Vue.prototype.configJson = configJson;

//多线程
import VueWorker from 'vue-worker'
Vue.use(VueWorker)

//title动态角标
let heads = document.getElementsByTagName('head');

let linkHtml=document.createElement('link');
let title=document.createElement('title');
title.innerHTML=configJson.CONFIG[baseUrl.DOMAIN_URL].title;
linkHtml.rel='icon';
linkHtml.href='/'+configJson.CONFIG[baseUrl.DOMAIN_URL].titleIcon;
linkHtml.type='image/png';

heads[0].appendChild(linkHtml);
heads[0].appendChild(title);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
